/*eslint-disable */
import Vue from 'vue'
import moment from 'moment';

Vue.filter('dateformat', (arg) => {
  return moment(arg).format('MMMM Do YYYY')
})
Vue.filter('timeformat', (arg) => {
  return moment(arg).format('h:mm:ss a')
})